import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  /**
   * Constructor
   */
  constructor(private _authService: AuthService, private _router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {





    if (this._authService.check() ) {
      
      return true;
      //  return this._authService.checkRoute()
      
    }

    this._router.navigate(['/sign-in'], {
      queryParams: {
        return: state.url,
      },
    });
    return false;
  }
}
